// prettier-ignore
module.exports = {
  /* Menu */
  "Dashboard":"Dashboard",
  

};
